const trail = [];
const trailLength = 8;

// Create trail elements
for (let i = 0; i < trailLength; i++) {
  const dot = document.createElement('div');
  dot.classList.add('cursor-trail-dot');
  dot.style.opacity = 1 - (i / trailLength);
  document.body.appendChild(dot);
  trail.push({ element: dot, x: 0, y: 0 });
}

let mouseX = 0, mouseY = 0;

document.addEventListener('mousemove', (e) => {
  mouseX = e.clientX;
  mouseY = e.clientY;
});

function animateTrail() {
  let currentX = mouseX;
  let currentY = mouseY;
  
  trail.forEach((dot, index) => {
    // Smooth trailing effect
    dot.x += (currentX - dot.x) * 0.2;
    dot.y += (currentY - dot.y) * 0.2;
    
    dot.element.style.left = dot.x + 'px';
    dot.element.style.top = dot.y + 'px';
    
    currentX = dot.x;
    currentY = dot.y;
  });
  
  requestAnimationFrame(animateTrail);
}

animateTrail();